import { useEffect } from 'react';

let timer: ReturnType<typeof setTimeout>;
export const useFormStepperAutoSubmit = (autoSubmit, watch, onFormSubmit, time = 1000) => {
  useEffect(() => {
    if (autoSubmit) {
      const subscription = watch(() => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          onFormSubmit();
        }, time);
      });
      return () => {
        subscription.unsubscribe();
        clearTimeout(timer);
      };
    }
  }, [watch]);
};
